import React from "react";
import { Eye, ExternalLink } from "lucide-react";

const DESTS = [
  { label: "Home / Esplora", path: "/esplora" },
  { label: "Home Smart", path: "/home" },
  { label: "Scopri", path: "/app/scopri" },
  { label: "Deals Fuma+", path: "/app/deals" },
  { label: "Rider Run", path: "/app/rider-run" },
  { label: "Profilo cliente", path: "/app/profile" },
  { label: "Passaporto", path: "/app/passaporto" },
  { label: "Missioni", path: "/app/missioni" },
];

export default function PreviewClientePanel() {
  const open = (path) => window.open(`${path}${path.includes("?") ? "&" : "?"}ceoPreview=1`, "_blank");
  return (
    <div className="space-y-5" data-testid="preview-cliente-panel">
      <div>
        <h2 className="font-display font-bold text-xl flex items-center gap-2"><Eye className="h-5 w-5 text-[#00E676]" /> Preview Cliente</h2>
        <p className="text-sm text-zinc-500">Apri l'app esattamente come la vede un cliente, in una nuova scheda. Un banner verde in alto ti permette di uscire dall'anteprima in qualsiasi momento. Utile per l'audit UX su ogni schermata.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="preview-dest-grid">
        {DESTS.map((x, i) => (
          <button key={x.path} data-testid={`preview-open-${i}`} onClick={() => open(x.path)}
            className="flex items-center justify-between gap-2 rounded-2xl bg-[#1C1C1F] border border-white/10 px-4 py-3 text-left hover:border-[#00E676]/40 transition-colors">
            <span className="font-medium text-white">{x.label}</span>
            <ExternalLink className="h-4 w-4 text-[#00E676]" />
          </button>
        ))}
      </div>
    </div>
  );
}
